<template>
  <div class="text-green-400 text-center text-xl">
    <p class="text-white text-xl font-bold" v-if="!internalError">الرجاء الانتظار ....</p>
    <h1 class="text-gray-500 text-4xl text-center mt-36" v-if="internalError">
      500|Server
    </h1>
  </div>
</template>

<script>
import { useAuthStore } from "@/stores/auth";
import { mapActions, mapState } from "pinia";
export default {
  data() {
    return {
      internalError: false,
    };
  },
  computed: {
    ...mapState(useAuthStore, ["isAuthenticated"]),
  },
  methods: {
    ...mapActions(useAuthStore, ["checkSubescriptionStatus"]),
   
  },
  async created() {
    const phone =  this.$route.params.num;

    try {
     const data = {
        phone: phone,
        cgstatus: this.$route.params.cgstatus,
        pupID: this.$route.params.pupID,
        clickID: this.$route.params.clickID,
      };
     const response = await this.checkSubescriptionStatus(data);
        if (response.data.token) {
          this.$router.push({ name: "home" });
        } else {
          this.$router.push({ name: "subscribe" });
        }
    
    } catch (error) {
      console.log(error);
    }
  },
};
</script>

<style></style>
